// Spieltest Phase 4 (Fabi), Runde 6: Hover-Infos. Wer genauer wissen will, was hinter einem Wert, einer Passive oder
// einem Ast steckt, fährt mit der Maus darüber. Ein einziges Kästchen für die ganze Seite, damit es nie abgeschnitten wird.

let tipBox: HTMLElement | null = null;
let freeTip = false;

/** K38 (Phase Kern): Erklärung zu einer Stelle ohne eigenes Element, etwa zum Zeichen einer Eigenschaft auf dem Ufer */
export function tipAt(text: string | null, rect?: { left: number; top: number; right: number; bottom: number }): void {
  const box = tipBox;
  if (!box) return;
  if (!text || !rect) {
    if (freeTip) box.classList.remove('on');
    freeTip = false;
    return;
  }
  freeTip = true;
  box.textContent = text;
  box.classList.add('on');
  const w = box.offsetWidth;
  const h = box.offsetHeight;
  const left = Math.max(8, Math.min(window.innerWidth - w - 8, (rect.left + rect.right) / 2 - w / 2));
  const below = rect.bottom + 8 + h < window.innerHeight;
  box.style.left = `${left}px`;
  box.style.top = `${below ? rect.bottom + 8 : rect.top - h - 8}px`;
}

export function initTips(): void {
  const box = document.createElement('div');
  box.id = 'tip';
  box.setAttribute('role', 'tooltip');
  document.body.appendChild(box);
  tipBox = box;
  let current: HTMLElement | null = null;

  const show = (el: HTMLElement) => {
    const text = el.dataset.tip;
    if (!text) return;
    current = el;
    box.textContent = text;
    box.classList.add('on');
    const r = el.getBoundingClientRect();
    const w = box.offsetWidth;
    const h = box.offsetHeight;
    const left = Math.max(8, Math.min(window.innerWidth - w - 8, r.left + r.width / 2 - w / 2));
    const below = r.bottom + 8 + h < window.innerHeight;
    box.style.left = `${left}px`;
    box.style.top = `${below ? r.bottom + 8 : r.top - h - 8}px`;
  };
  const hide = () => {
    current = null;
    if (!freeTip) box.classList.remove('on');
  };

  document.addEventListener('mouseover', (ev) => {
    const el = (ev.target as HTMLElement).closest<HTMLElement>('[data-tip]');
    if (el && el !== current) show(el);
    else if (!el && current) hide();
  });
  document.addEventListener('focusin', (ev) => {
    const el = (ev.target as HTMLElement).closest<HTMLElement>('[data-tip]');
    if (el) show(el);
  });
  document.addEventListener('focusout', hide);
  // Auf Touch-Geräten: Antippen zeigt die Info, Tippen daneben schließt sie
  document.addEventListener('click', (ev) => {
    const el = (ev.target as HTMLElement).closest<HTMLElement>('[data-tip]');
    if (el && el.tagName !== 'BUTTON') show(el);
  });
  window.addEventListener('scroll', hide, true);
}
